import { dialog } from "nq-component";
import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";
import { findObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import Queue from "nq";

class ScheduleFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  async handleFormSubmit() {
    const { name, scheduleArray } = this.view.state;
    const data = {
      name,
      description: this.view.state.description,
      ...this.view.state.hierarchy,
      scheduleArray,
      ...this.view.state.scheduleObject,
    };
    if (this.view.state.groupEmployee) {
      data.groupEmployee = this.view.state.groupEmployee;
    }
    if (data.name === "") {
      return this.showError("Name is Required!");
    }
    if (data.description === "") {
      return this.showError("Descripiton is Required!");
    }

    if (data.scheduleArray.length === 0) {
      return this.showError("schedule Required!");
    }

    this.view.setState({ isProgress: true });

    if (this.view.state.object.id) {
      data.id = this.view.state.object.id;
      const employeesSched = await findObjectUseCase().execute("employees", {
        where: { selectedSchedule: { id: data.id } },
        keys: ["id"],
      });
      if (employeesSched.length > 0) {
        const scheduleTemp = await this.getObjectUseCase.execute(
          "schedule_template",
          data.id,
        );
        if (!scheduleTemp) return;
        for (const emp of employeesSched) {
          const empSched = {
            id: emp.id,
            selected_schedule_assignment: {
              employeeId: emp.id,
              name: scheduleTemp.name,
              scheduleArray: scheduleTemp.scheduleArray,
              startingDate: scheduleTemp.startingDate,
              selectedOption: scheduleTemp.selectedOption,
              sequence: scheduleTemp.sequence,
            },
          };
          await upsertUseCase().execute("employees", empSched);
        }
      }
    }
    try {
      // console.log("DATA: ", data);
      // return;
      const schedResponse = await upsertUseCase().execute(
        this.view.getCollectionName(),
        data,
      );

      // // delete old Cronjobs
      // if (data.id) {
      //   console.log("HAS ID");
      //   await this.DeleteJobConfiguration(data.id);
      // }

      // //add Conjob on every schedule
      // await this.CronJobConfiguration(schedResponse);

      // // udpate emp group schedule
      // if (data.groupEmployee && Object.keys(data.groupEmployee).length > 0) {
      //   const groupSched = await findObjectUseCase().execute("group_schedule", {
      //     where: { id: data.groupEmployee.id },
      //     include: ["groupEmployee"],
      //     keys: ["groupEmployee"],
      //   });
      //   if (groupSched[0].groupEmployee.length > 0) {
      //     groupSched[0].groupEmployee.map(async (employee) => {
      //       employee.selectedSchedule = { id: schedResponse.id };
      //       await upsertUseCase().execute("employees", employee);
      //     });
      //   }
      // }

      // //doplicate schedule for webhook absences and cronJOBS
      // if (!data.id) {
      //   await this.InsertMockScheduleTemplate(schedResponse);
      // }

      // update using orgstructure
      //// comment this  at the moment
      // if (data.region && data.region !== "") {
      //   const fields = [
      //     "region",
      //     "office",
      //     "division",
      //     "section",
      //     "unit",
      //     "cluster",
      //   ];
      //   const lastNonEmptyField = fields
      //     .slice()
      //     .reverse()
      //     .find((field) => data[field] && data[field] !== "");

      //   const employees = await findObjectUseCase().execute("employees", {
      //     where: { [lastNonEmptyField]: data[lastNonEmptyField] },
      //     keys: ["selectedSchedule"],
      //   });

      //   // console.log("EMPLOYEESS: ", employees);
      //   if (employees.length > 0) {
      //     // updateEmployees(employees, schedResponse)
      //     for (const obj of employees) {
      //       try {
      //         const emp = {
      //           selectedSchedule: { id: schedResponse.id },
      //           id: obj.id,
      //         };
      //         await upsertUseCase().execute("employees", emp);
      //       } catch (e) {
      //         console.error(e);
      //       }
      //     }
      //   }
      // }
      dialog.close();
      this.view.setState({ isProgress: false });
      this.view.showSuccess("Success!");
      this.view.onClickBack();
    } catch (e) {
      console.error(e);
      this.showError(e.message);
    }
  }

  // async InsertMockScheduleTemplate(schedResponse) {
  //   const data = {
  //     scheduleID: schedResponse.id,
  //   };
  //   await upsertUseCase().execute("_schedule_template", data);
  // }

  // async DeleteJobConfiguration(id) {
  //   const cronJob = await findObjectUseCase().execute("_cronjobs", {
  //     where: { scheduleID: id },
  //   });
  //   if (cronJob.length > 0) {
  //     for (const cron of cronJob) {
  //       try {
  //         await new Queue.Document().delete("_cronjobs", cron.id);
  //       } catch (e) {
  //         console.error("cronDelete: ", e.message || e);
  //       }
  //     }
  //   }
  //   return "success";
  // }

  // async CronJobConfiguration(schedResponse) {
  //   if (
  //     !Array.isArray(schedResponse.scheduleArray) &&
  //     schedResponse.scheduleArray.length === 0
  //   )
  //     return;

  //   const dayMap = {
  //     Monday: 1,
  //     Tuesday: 2,
  //     Wednesday: 3,
  //     Thursday: 4,
  //     Friday: 5,
  //     Saturday: 6,
  //     Sunday: 0,
  //   };

  //   const is4daysCycle = schedResponse?.selectedOption.includes(
  //     "4days Working, 2days off",
  //   );
  //   const is3daysCycle = schedResponse?.selectedOption.includes(
  //     "3days Working, 3days off",
  //   );

  //   // regular
  //   // No startingDate or not a cycle? → just use the original scheduleArray
  //   if (!schedResponse.startingDate || (!is4daysCycle && !is3daysCycle)) {
  //     await this.IncrementCronJobs(schedResponse, dayMap);
  //     return;
  //   }

  //   // check if schedule cycle
  //   const startCycle = new Date(schedResponse.startingDate);
  //   const workDaysCount = is4daysCycle ? 4 : 3; // 4 working days or 3 working days
  //   const baseSchedule = schedResponse.scheduleArray[0];

  //   const weekdayNames = [
  //     "Sunday",
  //     "Monday",
  //     "Tuesday",
  //     "Wednesday",
  //     "Thursday",
  //     "Friday",
  //     "Saturday",
  //   ];

  //   const generatedSchedules = [];

  //   for (let i = 0; i < workDaysCount; i++) {
  //     const cycleDate = startCycle;
  //     cycleDate.setDate(cycleDate.getDate() + i); // add 0,1,2,3 days from startingDate

  //     const weekdayName = weekdayNames[cycleDate.getDay()]; // e.g. "Monday", "Tuesday", ...

  //     generatedSchedules.push({
  //       ...baseSchedule,
  //       day: weekdayName, // override day with actual weekday
  //     });
  //   }

  //   const schedForCron = {
  //     ...schedResponse,
  //     scheduleArray: generatedSchedules,
  //   };

  //   await this.IncrementCronJobs(schedForCron, dayMap);
  //   return;
  // }

  // async IncrementCronJobs(schedResponse, day) {
  //   for (const schedule of schedResponse.scheduleArray) {
  //     let timeout = schedule.timeout;
  //     if (schedule.earliestTimeOut) {
  //       timeout = schedule.earliestTimeOut;
  //     }

  //     const [hourStr, minuteStr] = timeout.split(":");

  //     let hours = parseInt(hourStr, 10);
  //     let minutes = parseInt(minuteStr, 10);
  //     let dayIndex = day[schedule.day];
  //     if (schedule.day.includes(" - ")) {
  //       const [dayOne, dayTwo] = schedule.day.split(" - ");
  //       dayIndex = day[dayTwo];
  //     }

  //     switch (hours) {
  //       case 20:
  //         hours = (hours - 5 + 24) % 24;
  //         break;
  //       case 21:
  //         hours = (hours - 6 + 24) % 24;
  //         minutes = 30;
  //         break;
  //       case 22:
  //         hours = (hours - 7 + 24) % 24;
  //         minutes = 50;
  //         break;
  //       case 23:
  //         hours = (hours - 8 + 24) % 24;
  //         minutes = 50;
  //         break;
  //       default:
  //         // subract 8h by default but the duration of the trigger should be 4hrs
  //         // subtract 4 hours with 24-hour wraparound
  //         hours = (hours - 4 + 24) % 24;
  //         break;
  //     }

  //     const cronData = {
  //       expression: `${String(minutes).padStart(2, "0")} ${String(
  //         hours,
  //       )} * * ${dayIndex}`, //min, hour, day, month, week
  //       action: "update",
  //       collection: "_schedule_template", //collection
  //       payload: {
  //         isUpdate: true, //updated field on target collection
  //       },
  //       where: {
  //         scheduleID: schedResponse.id, //updated field on target collection
  //       },
  //       scheduleID: schedResponse.id,
  //     };

  //     await upsertUseCase().execute("_cronjobs", cronData);
  //   }
  // }
}

export default ScheduleFormPresenter;
